import {
    AppstoreOutlined,
    AreaChartOutlined,
    ArrowsAltOutlined,
    BarChartOutlined,
    SaveOutlined,
    CheckCircleOutlined,
    FileDoneOutlined,
    FilterOutlined,
    FolderOutlined,
    LeftCircleOutlined,
    PicLeftOutlined,
    PictureOutlined,
    RightCircleOutlined,
    RetweetOutlined,
    StopOutlined,
    TagsOutlined,
    UnorderedListOutlined,
    UserOutlined
} from '@ant-design/icons'
import { AccountBean } from 'src/api/api'
import * as routes from 'src/constants/routes'
import RoleEnum = AccountBean.RoleEnum

type SidebarTab = {
    name: string
    key: string
    hasDropdown?: boolean
    button?: boolean
    content?: DropdownContent[]
    url?: string
    icon: typeof AreaChartOutlined
    isConfigTab?: boolean
    fullAccess?: boolean
    roles: RoleEnum[]
}

type DropdownContent = {
    name: string
    url: string
    icon?: typeof AreaChartOutlined
}

export const statisticTabs: SidebarTab[] = [
    {
        name: 'Dashboard',
        key: `${routes.DASHBOARD.substring(1)}`,
        url: `${routes.DASHBOARD}`,
        icon: AppstoreOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin, RoleEnum.AgencyManager]
    },
    {
        name: 'Report',
        key: `${routes.REPORT_BUILDER.substring(1)}`,
        url: `${routes.REPORT_BUILDER}`,
        icon: BarChartOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin, RoleEnum.AgencyManager]
    },
    {
        name: 'Saved Report',
        key: `${routes.SAVED_REPORT.substring(1)}`,
        url: `${routes.SAVED_REPORT}`,
        icon: SaveOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin, RoleEnum.AgencyManager]
    }
]

export const supplyTabs: SidebarTab[] = [
    {
        name: 'SSP',
        key: `${routes.SSP.substring(1)}`,
        url: `${routes.SSP}`,
        icon: RightCircleOutlined,
        roles: [RoleEnum.Admin]
    }
]

export const demandTabs: SidebarTab[] = [
    {
        name: 'Media Agency',
        key: `${routes.MEDIA_AGENCY.substring(1)}`,
        url: `${routes.MEDIA_AGENCY}`,
        icon: FileDoneOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin]
    },
    {
        name: 'Advertiser',
        key: `${routes.ADVERTISER.substring(1)}`,
        url: `${routes.ADVERTISER}`,
        icon: LeftCircleOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin, RoleEnum.AgencyManager]
    },
    {
        name: 'Campaign',
        key: `${routes.CAMPAIGN.substring(1)}`,
        url: `${routes.CAMPAIGN}`,
        icon: FolderOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin, RoleEnum.AgencyManager]
    },
    {
        name: 'Ad Group',
        key: `${routes.AD_GROUP.substring(1)}`,
        url: `${routes.AD_GROUP}`,
        icon: PicLeftOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin, RoleEnum.AgencyManager]
    },
    {
        name: 'Creative',
        key: `${routes.CREATIVE.substring(1)}`,
        url: `${routes.CREATIVE}`,
        icon: PictureOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin, RoleEnum.AgencyManager]
    }
]

export const adminTabs: SidebarTab[] = [
    {
        name: 'Account',
        key: `${routes.ACCOUNT.substring(1)}`,
        url: `${routes.ACCOUNT}`,
        icon: UserOutlined,
        roles: [RoleEnum.Admin]
    },
    {
        name: 'Ad Size',
        key: `${routes.AD_SIZE.substring(1)}`,
        url: `${routes.AD_SIZE}`,
        icon: ArrowsAltOutlined,
        roles: [RoleEnum.Admin]
    },
    {
        name: 'Filter List',
        key: `${routes.FILTER_LIST.substring(1)}`,
        url: `${routes.FILTER_LIST}`,
        icon: FilterOutlined,
        roles: [RoleEnum.Admin, RoleEnum.AgencyAdmin, RoleEnum.AgencyManager]
    },
    {
        name: 'Retargeting List',
        key: `${routes.RETARGETING_LIST.substring(1)}`,
        url: `${routes.RETARGETING_LIST}`,
        icon: RetweetOutlined,
        roles: [RoleEnum.Admin]
    },
    {
        name: 'Fraud Domain',
        key: `${routes.FRAUD_DOMAIN.substring(1)}`,
        url: `${routes.FRAUD_DOMAIN}`,
        icon: StopOutlined,
        roles: [RoleEnum.Admin]
    },
    {
        name: 'Contextual Targeting',
        key: `${routes.CONTEXTUAL_TARGETING.substring(1)}`,
        url: `${routes.CONTEXTUAL_TARGETING}`,
        icon: TagsOutlined,
        roles: [RoleEnum.Admin]
    },
    {
        name: 'Test Request',
        key: `${routes.TEST_REQUEST.substring(1)}`,
        url: `${routes.TEST_REQUEST}`,
        icon: CheckCircleOutlined,
        roles: [RoleEnum.Admin]
    },
    {
        name: 'Log',
        key: `${routes.LOG.substring(1)}`,
        url: `${routes.LOG}`,
        icon: UnorderedListOutlined,
        roles: [RoleEnum.Admin]
    }
]


// WEBPACK FOOTER //
// ./src/constants/sidebarTabs.ts